import { render, staticRenderFns } from "./PaymentLinkDetail.vue?vue&type=template&id=232f0377"
import script from "./PaymentLinkDetail.vue?vue&type=script&lang=js"
export * from "./PaymentLinkDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports